<div class="overflow-auto w-100">
  <div class="mb-1">
    <bdg-label type="subheading-1">{{ title }}</bdg-label>
  </div>
  <mat-label *ngIf="text; else noText" class="mat-body-1" style="white-space: pre-line; overflow: auto;">{{
    text
  }}</mat-label>
  <ng-template #noText>
    <bdg-label>-</bdg-label>
  </ng-template>
</div>
